module.exports = __webpack_public_path__ + "img/矩形3.18cca208.svg";